import "core-js/modules/es6.object.assign.js";
export var listenOpts = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
};
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      Object.assign(listenOpts, {
        hasPassive: true,
        passive: {
          passive: true
        },
        notPassive: {
          passive: false
        },
        passiveCapture: {
          passive: true,
          capture: true
        },
        notPassiveCapture: {
          passive: false,
          capture: true
        }
      });
    }
  });
  window.addEventListener('qtest', null, opts);
  window.removeEventListener('qtest', null, opts);
} catch (e) {}
export function noop() {}
export function leftClick(e) {
  return e.button === 0;
}
export function middleClick(e) {
  return e.button === 1;
}
export function rightClick(e) {
  return e.button === 2;
}
export function position(e) {
  if (e.touches && e.touches[0]) {
    e = e.touches[0];
  } else if (e.changedTouches && e.changedTouches[0]) {
    e = e.changedTouches[0];
  } else if (e.targetTouches && e.targetTouches[0]) {
    e = e.targetTouches[0];
  }
  return {
    top: e.clientY,
    left: e.clientX
  };
}
export function getEventPath(e) {
  if (e.path) {
    return e.path;
  }
  if (e.composedPath) {
    return e.composedPath();
  }
  var path = [];
  var el = e.target;
  while (el) {
    path.push(el);
    if (el.tagName === 'HTML') {
      path.push(document);
      path.push(window);
      return path;
    }
    el = el.parentElement;
  }
}

// Reasonable defaults
var LINE_HEIGHT = 40,
  PAGE_HEIGHT = 800;
export function getMouseWheelDistance(e) {
  var x = e.deltaX,
    y = e.deltaY;
  if ((x || y) && e.deltaMode) {
    var multiplier = e.deltaMode === 1 ? LINE_HEIGHT : PAGE_HEIGHT;
    x *= multiplier;
    y *= multiplier;
  }
  if (e.shiftKey && !x) {
    var _ref = [x, y];
    y = _ref[0];
    x = _ref[1];
  }
  return {
    x: x,
    y: y
  };
}
export function stop(e) {
  e.stopPropagation();
}
export function prevent(e) {
  e.cancelable !== false && e.preventDefault();
}
export function stopAndPrevent(e) {
  e.cancelable !== false && e.preventDefault();
  e.stopPropagation();
}
export function stopAndPreventClick(evt) {
  stopAndPrevent(evt);
  if (evt.type === 'mousedown') {
    var handler = function handler(e) {
      e.target === evt.target && stopAndPrevent(e);
      document.removeEventListener('click', handler, listenOpts.notPassiveCapture);
    };
    document.addEventListener('click', handler, listenOpts.notPassiveCapture);
  }
}
export function preventDraggable(el, status) {
  if (el === void 0 || status === true && el.__dragPrevented === true) {
    return;
  }
  var fn = status === true ? function (el) {
    el.__dragPrevented = true;
    el.addEventListener('dragstart', prevent, listenOpts.notPassiveCapture);
  } : function (el) {
    delete el.__dragPrevented;
    el.removeEventListener('dragstart', prevent, listenOpts.notPassiveCapture);
  };
  el.querySelectorAll('a, img').forEach(fn);
}
export function create(name) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$bubbles = _ref2.bubbles,
    bubbles = _ref2$bubbles === void 0 ? false : _ref2$bubbles,
    _ref2$cancelable = _ref2.cancelable,
    cancelable = _ref2$cancelable === void 0 ? false : _ref2$cancelable;
  try {
    return new CustomEvent(name, {
      bubbles: bubbles,
      cancelable: cancelable
    });
  } catch (e) {
    // IE doesn't support `new Event()`, so...
    var evt = document.createEvent('Event');
    evt.initEvent(name, bubbles, cancelable);
    return evt;
  }
}
export function addEvt(ctx, targetName, events) {
  var name = "__q_".concat(targetName, "_evt");
  ctx[name] = ctx[name] !== void 0 ? ctx[name].concat(events) : events;
  events.forEach(function (evt) {
    evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
  });
}
export function cleanEvt(ctx, targetName) {
  var name = "__q_".concat(targetName, "_evt");
  if (ctx[name] !== void 0) {
    ctx[name].forEach(function (evt) {
      evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
    });
    ctx[name] = void 0;
  }
}

/*
 * also update /types/utils/event.d.ts
 */

export default {
  listenOpts: listenOpts,
  leftClick: leftClick,
  middleClick: middleClick,
  rightClick: rightClick,
  position: position,
  getEventPath: getEventPath,
  getMouseWheelDistance: getMouseWheelDistance,
  stop: stop,
  prevent: prevent,
  stopAndPrevent: stopAndPrevent,
  preventDraggable: preventDraggable,
  create: create
};